import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { DataGrid } from "@mui/x-data-grid";

export default function StatsOfMatch() {
  const jsonMetadata = useSelector((state) => state.jsonMetadata.value);
  const issues = jsonMetadata.issues || [];

  // Agregar un id único a cada fila para DataGrid
  const rows = issues.map((issue, idx) => ({
    id: idx, // id único basado en el índice
    ...issue,
    ...issue.valor,
  }));

  // Función para exportar a Excel
  const exportToExcel = () => {
    const data = issues.map((issue) => ({
      Card: issue.nombre ? issue.nombre : issue,
      Vote: issue.valor ? issue.valor.voto : "-",
      Hours: issue.horas ? issue.horas : "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Resultados");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(blob, "votacion.xlsx");
  };

  const columns = [
    {
      field: "nombre",
      headerName: "Card",
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "bold-header",
    },
    {
      field: "voto",
      headerName: "Votes",
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "bold-header",
    },
    {
      field: "horas",
      headerName: "Hours",
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "bold-header",
    },
  ];

  return (
    <div>
      <div className="App-header">
        <h2>Results</h2>
        <button className="btn btn-success mb-3" onClick={exportToExcel}>
          Export to Excel
        </button>
        <div style={{ height: 400, width: "80%" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
          />
          <a
            href="/"
            style={{
              color: "white",
              textDecoration: "none",
              padding: 10,
              marginTop: 10,
            }}
          >
            New Votes
          </a>
        </div>
      </div>
    </div>
  );
}
